'use strict';

module.exports = require('./AutosuggestContainer').default;


//////////////////
// WEBPACK FOOTER
// ./~/react-autosuggest/dist/index.js
// module id = 2267
// module chunks = 0